import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import { Loader } from "./Components/Loader";
import { Manage } from "./Components/Manage";
import { useLenis } from "./hooks/useLenis";

const App = () => {
  const [loading, setLoading] = useState(true);
  
  // Initialize smooth scrolling
  useLenis();

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      {loading ? <Loader /> : <Manage />}
    </Router>
  );
};

export default App;
